/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import exciseService from './../../../../services/exciseEntry';
import debounce from 'debounce';
import SearchMixin from './../../../../mixins/search';
import exciseGroupService from './../../../../services/exciseGroup';
import additionalCodeSrvice from './../../../../services/additionalCode';
import productService from './../../../../services/product';
import accountService from './../../../../services/account';
import helpers from './../../../../utils/helpers';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
      entries: [],
      filter: {
        product: '',
        month: moment().subtract(1, 'months'),
      },
      form: new Forms({
        product: {
          type: 'autocomplete',
          value: '',
          attributes: {
            isSearch: true,
            searchMethod: this.searchMethod,
            loading: true,
          },
        },
      }),
      dateRange: [moment().subtract(1, 'months'), moment()],
      pagination: {},
      page: 1,
      limit: 25,
      flag: '',
    };
  },

  computed: {
    ...mapGetters({
      warehouses: 'paginateWarehouses',
      products: 'allProducts',
    }),

    warehousesList() {
      return this.warehouses.items.map(b =>
       /* let cardClass = '';

        if (b.billStatus === 'Overdue') {
          cardClass = 'card-red';
        } else if (b.billStatus === 'Cleared') {
          cardClass = 'card-green';
        } else if (b.billStatus === 'Sent') {
          cardClass = 'card-yellow';
        }

        Object.assign(b, {
          number: b.billingNumber ? `#${b.billingNumber}` : 'Draft',
          value: `${b.totalValue.toFixed(2)} NOK`,
          amount: `(${b.totalQuantity} ${this.$t('static.bills.index.quantities')})`,
          dueDateFormated: moment(b.dueDate).isValid() ? moment(b.dueDate).format('DD-MM-YYYY') : '-',
          cardClass,
        });*/

         b);
    },
  },

  watch: {
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
     // this.all(1, 50);
    },

    'form.product': function (val) {
      this.all(this.page, this.limit);
    },
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
    VTable: require('./../../../../components/table/table.vue'),
    VExciseTable: require('./../../../../components/exciseTable/exciseTable.vue'),
    VForm: require('./../../../../components/form/form.vue'),
  },

  mixins: [
    SearchMixin,
  ],

  mounted() {
    let product_id = '';
    if (this.form.product != '') {
      product_id = this.form.product.id;
    }
    let month = '';

    if (this.filter.month != null) {
      month = moment(this.filter.month).format('YYYY-MM');
    }
    const params = {
      page: 1,
      limit: 50,
      month,
      product: product_id,
      flag: this.flag,
    };
    Promise.all([
      exciseService.entries(params),
      exciseGroupService.all(),
      exciseGroupService.packaging(),
      exciseGroupService.basic(),
      additionalCodeSrvice.all(),
      // productService.all()
    ]).then((data) => {
      this.entries = data[0].report;
     // this.pagination = data[0].pagination;
      this.loading = false;
    });

    accountService.rememberPerPage('get', { from: 'excise_entry' })
    .then((data) => {
      this.limit = data.size;
      this.all(1, this.limit);
    }).catch((error) => {
      console.log(error);
    });
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'excise_entry', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    /**
     * Fetches paginated warehouse.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all: debounce(function (page, limit) {
      this.loading = true;
      this.page = page;
      this.limit = limit;


      let productId = '';
      if (this.form.product !== '') {
        productId = this.form.product.id;
      }
      let month = '';

      if (this.filter.month != null) {
        month = moment(this.filter.month).format('YYYY-MM');
      }
      exciseService.entries({
        page,
        limit,
        month,
        product: productId,
        flag: this.flag,
      }).then((data) => {
        this.entries = data.report;
        this.pagination = data.pagination;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }, 800),

    searchMethod(search, field) {
      this.form.setAttrValue('product', 'loading', true);
      // console.log(field);

      return Promise.all([
        productService.search({ search, warehouse_id: this.form.warehouseId }),
      ]);
    },
    updateList(index, data) {
      // this.entries[index] = data;

      this.all(this.page, this.limit);
    },

    changeData() {
      this.loading = true;
      this.all(this.page, this.limit);
    },

    openLink(row) {
      if (row.excisable == 'order') {
        this.$router.push({
          name: 'orders.edit',
          params: { id: row.excisableId },
        });
      } else if (row.excisable == 'creditnote') {
        this.$router.push({
          name: 'bills.creditNote',
          params: { id: row.excisableId },
        });
      } else {
        this.$router.push({
          name: 'inventory.purchase.view',
          params: { id: row.excisableId },
        });
      }
    },
    exportData() {
      let month = '';
      if (this.filter.month != null) {
        month = moment(this.filter.month).format('YYYY-MM');
      }

      const params = {
        page: this.page,
        limit: this.limit,
        month,
        product: this.filter.product,
        flag: this.flag,
      };

      Promise.all([exciseService.checkFlag(params)]).then((data) => {
        params.flag = true;
        this.flag = true;
        if (data[0].data > 0) {
          this.$message({
            showClose: true,
            message: data[0].message,
            customClass: 'error',
          });
          this.loading = true;
          exciseService.entries(params).then((data) => {
            this.entries = data.report;
            this.pagination = data.pagination;
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        } else {
          window.open(helpers.buildUrl(`${process.env.API_LOCATION}/excise_entries/export/`, {
            token: localStorage.getItem('id_token'),
            ...params,
          }));
        }
      });
      // exciseService.entries(params).then((data) => {
      //     this.entries = data.report;
      //     this.pagination = data.pagination;
      //     this.loading = false;
      //   }).catch(() => {
      //     this.loading = false;
      //   });
    },
    /**
     * Go to edit view for warehouse.
     *
     * @param  {Object} warehouse The warehouse object.
     */
    editWarehouse(warehouse) {
      const name = 'warehouse.edit';
      this.$router.push({
        name,
        params: { id: warehouse.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/exciseEntry/index/index.js